import React, { forwardRef } from "react";
import { styled } from "goober";

import { IS_APP } from "@/__main__/constants.mjs";
import MainNavGameLinksBar from "@/app/AppShellMainNavGameLinksBar.jsx";
import MainNavGamesBar from "@/app/AppShellMainNavGamesBar.jsx";
import MainNavSearchBar from "@/app/AppShellMainNavSearchBar.jsx";
import { useRoute } from "@/util/router-hooks.mjs";

const Wrapper = styled("div", forwardRef)`
  container-type: inline-size;
  container-name: main-nav;
  width: 100%;
  position: relative;
  top: 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  background: var(--nav-bg);
  z-index: 3;
`;

function MainNavApp() {
  return (
    <Wrapper>
      <MainNavGameLinksBar />
    </Wrapper>
  );
}

function MainNavWeb() {
  const { currentPath } = useRoute({
    isGlobal: true,
  });

  const isHome = currentPath === "/";

  return (
    <Wrapper className={`${isHome ? "home" : ""}`}>
      <MainNavGamesBar currentPath={currentPath} />
      <MainNavSearchBar currentPath={currentPath} />
      {!isHome && <MainNavGameLinksBar />}
    </Wrapper>
  );
}

export default function MainNav() {
  return IS_APP ? <MainNavApp /> : <MainNavWeb />;
}
